import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { Subscription } from 'Internal.CommonAPI';
import { HubSpotWidget } from './HubSpot';
import { IntercomChatbotWidget } from './Intercom';
import BeamerWidget from './Beamer';
import DelightedNPSWidget from './Delighted';

const Widgets: React.FC = () => {
  const { locale } = useIntl();
  const currentLocale = locale.toLowerCase();
  const queryClient = useQueryClient();
  const isTrialUser = queryClient.getQueryData([
    'account',
    'isTrialUser',
  ]) as boolean;
  const email = queryClient.getQueryData(['account', 'email']) as string;
  const country = queryClient.getQueryData(['account', 'country']) as string;
  const signUpDate = queryClient.getQueryData([
    'account',
    'signUpDate',
  ]) as Date;
  const id = queryClient.getQueryData(['account', 'id']) as number;
  const merchant_id = queryClient.getQueryData([
    'account',
    'merchant_id',
  ]) as string;
  const activeSubscriptions = queryClient.getQueryData([
    'account',
    'activeSubscriptions',
  ]) as Subscription[];

  if (email && id && isTrialUser !== undefined) {
    const showHubspot = isTrialUser;
    const showIntercom = isTrialUser === false;

    return (
      <>
        {showHubspot && (
          <HubSpotWidget
            email={email}
            locale={currentLocale}
            accountId={id}
            isTrialUser={isTrialUser}
          />
        )}
        {showIntercom && (
          <IntercomChatbotWidget
            accountId={id}
            email={email}
            locale={currentLocale}
            signUpDate={signUpDate}
            merchantId={merchant_id || ''}
            isTrialUser={isTrialUser}
          />
        )}
        <BeamerWidget email={email} accountId={id} />
        {activeSubscriptions !== undefined &&
          signUpDate !== undefined &&
          country !== undefined && (
            <>
              <DelightedNPSWidget
                accountId={id}
                email={email}
                country={country}
                subscriptions={activeSubscriptions}
              />
            </>
          )}
      </>
    );
  }

  return null;
};
export default Widgets;
